import styled from "@emotion/styled";
import { DateTimeFormatter, LocalTime } from "@js-joda/core";
import React from "react";
import ChatAvatar from "./ChatAvatar";
import ChatMessage from "./ChatMessage";
import ChatMessageBubble from "./ChatMessageBubble";
import ChatMessageContent from "./ChatMessageContent";

interface Props {
  avatarUrl: string | null;
  senderName: string;
}

const timeFormatter = DateTimeFormatter.ofPattern("HH:mm");

function ChatRoomTypingIndicator(props: Props) {
  return (
    <ChatMessage.Root variant="incoming">
      <ChatAvatar url={props.avatarUrl} />
      <ChatMessageBubble variant="incoming">
        <ChatMessageBubble.Header>
          <span>{props.senderName}</span>
          <ChatMessageBubble.Time>{LocalTime.now().format(timeFormatter)}</ChatMessageBubble.Time>
        </ChatMessageBubble.Header>
        <ChatMessageContent.Root>
          <ChatMessageContent.Item>
            <ChatRoomTypingIndicator.Root>
              <ChatRoomTypingIndicator.Indicator />
            </ChatRoomTypingIndicator.Root>
          </ChatMessageContent.Item>
        </ChatMessageContent.Root>
      </ChatMessageBubble>
    </ChatMessage.Root>
  );
}

ChatRoomTypingIndicator.Root = styled.div`
  padding: 4px 16px;
`;
ChatRoomTypingIndicator.Indicator = styled.div`
  position: relative;
  width: 5px;
  height: 5px;
  border-radius: 5px;
  background-color: #3077eb;
  color: #3077eb;
  animation: dotFlashing 1s infinite linear alternate;
  animation-delay: 0.5s;

  &::before,
  &::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
  }

  &::before {
    left: -10px;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: #3077eb;
    color: #3077eb;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 0s;
  }

  &::after {
    left: 10px;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background-color: #3077eb;
    color: #3077eb;
    animation: dotFlashing 1s infinite alternate;
    animation-delay: 1s;
  }

  @keyframes dotFlashing {
    0% {
      background-color: #3077eb;
    }
    50%,
    100% {
      background-color: rgb(48 119 235 / 40%);
    }
  }
`;

export default ChatRoomTypingIndicator;
